import { render, staticRenderFns } from "./Mycollection.vue?vue&type=template&id=748f86b8&scoped=true"
import script from "./Mycollection.vue?vue&type=script&lang=js"
export * from "./Mycollection.vue?vue&type=script&lang=js"
import style0 from "./Mycollection.vue?vue&type=style&index=0&id=748f86b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748f86b8",
  null
  
)

export default component.exports